module.exports = __webpack_public_path__ + "img/heartFilled.b48209ba.svg";